"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VDraggableModalProvider = void 0;
var react_1 = __importStar(require("react"));
var DraggableModalContext_1 = require("./DraggableModalContext");
var utils_1 = require("./utils");
var draggableModalReducer_1 = require("./draggableModalReducer");
var VDraggableModalProvider = function (_a) {
    var children = _a.children;
    var _b = (0, react_1.useReducer)(draggableModalReducer_1.draggableModalReducer, draggableModalReducer_1.initialModalsState), state = _b[0], dispatch = _b[1];
    (0, react_1.useEffect)(function () {
        if (typeof window !== 'object') {
            return;
        }
        var onResize = function () {
            return dispatch({ type: 'windowResize', size: (0, utils_1.getWindowSize)() });
        };
        window.addEventListener('resize', onResize);
        onResize();
        return function () { return window.removeEventListener('resize', onResize); };
    }, [dispatch]);
    return (react_1.default.createElement(DraggableModalContext_1.DraggableModalContext.Provider, { value: {
            state: state,
            dispatch: dispatch
        } }, children));
};
exports.VDraggableModalProvider = VDraggableModalProvider;
